import React, { useState } from 'react';
import InputForm from '../../InputT';
import { Box, Tooltip } from '@mui/material';
import { Button, Form, Input, Modal, Select, Space } from 'antd';
import { ColumnsType } from 'antd/es/table';
import Table from '../../TableResizable';
import { Add, Delete, MoneyOffCsredOutlined } from '@mui/icons-material';
import Datas from "../../../Data/Data.json"
import { useAuthHeader } from '../../../Services/Auth/sessionAuth';
import axios from 'axios';
import SweetAlert from "sweetalert2"
import Data from '../../../Data/Data.json'
import OptionSelect from '../../../Types/OptionSelect';


interface DataType {
    key: string;
    NUMCPT: string;
    CODREL: string;
    LIMITE: string;
    Nomrel?:string;
    TelRel?:string;
    photo?:string;
    signature?:string;
    Expire?:string;
}


function Tab3(props:{form?: any,OptionSignataire?: OptionSelect[]}){

  const [Donnee,setDonnee]=React.useState<DataType[]>([]);
  const [pageIsLoad, setPageIsLoad] = useState(true);
  const [CODREL, setCODREL] = useState<string>();
  const [LIMITE, setLIMITE] = useState<string>();
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  // USER TOKEN
  const authHeader = useAuthHeader();
  const handleCancel = () => setPreviewOpen(false);


  const columns: ColumnsType<DataType> = [
  {
    title: ' Compte',
    dataIndex: 'NUMCPT',
    ellipsis: true,
    width: 150,
    render: (text) => <a>{text}</a>
  },
  {
    title: 'Code ',
    dataIndex: 'CODREL',
    ellipsis: true,
    width: 150,
  },
  {
    title: 'Plafond ',
    dataIndex: 'LIMITE',
    ellipsis: true,
    width: 150,
    render: (_,text)=>(<span>
              {text.LIMITE} FCFA
    </span>)
  },
  {
    title: 'Nom ',
    dataIndex: 'Nomrel',
    ellipsis: true,
    width: 150,
  },
  {
    title: 'Tel ',
    dataIndex: 'TelRel',
    ellipsis: true,
    width: 150,
  },
  {
    title: 'Expire',
    dataIndex: 'Expire',
    ellipsis: true,
    width: 150,
  },
  {
    title: 'Photo',
    dataIndex: 'photo',
    ellipsis: true,
    width: 150,
    render: (text: any, record: any) => (
      <span>
        <img
          onClick={e => { setPreviewImage(record.photo); setPreviewTitle("Preview Image"); setPreviewOpen(true); }}
          style={{ height: 50, width: 50 }}
          src={record.photo}
        ></img>
      </span>)
  },
  {
    title: 'Signature',
    ellipsis: true,
    width: 150,
    dataIndex: 'signature',
    render: (text: any, record: any) => (
      <span>
        <img
          onClick={e => { setPreviewImage(record.signature); setPreviewTitle("Preview Image"); setPreviewOpen(true); }}
          style={{ height: 50, width: 50 }}
          src={record.signature}
        ></img>
      </span>)
  }
  ,
  {
    title: 'Action',
    key: 'action',
    ellipsis: true,
    width: 100,
    render: (_, record) => (
      <Space size="middle">
        <Tooltip title='Retirer de la liste'>
        <Button color='error' icon={<Delete color='error' />} onClick={()=>{
          let newRows : DataType[] = [];     
          Donnee.map((d)=>{
            if(!(d.CODREL === record.CODREL && d.LIMITE === record.LIMITE)){  
              newRows.push(d)
            }
         
            setDonnee(newRows);
          })

          setDonnee(newRows)
          localStorage.setItem(Data.LocalVariable.Procurcpt,JSON.stringify(newRows))
          //localStorage.setItem(Datas.LocalVariable.groupPlanCp, Crypter.encrypt(JSON.stringify(d)))
        }} />
        </Tooltip>
      </Space>
    ),
  },
  {
    title: 'CNI',
    dataIndex: 'cni',
    ellipsis: true,
    width: 150,
    
  }
];

  const handleChangeAgence = (value: string) => {
    setCODREL(value);
  };
  const handleChangeGroupe = (e:any) => {
    setLIMITE(e);
  };

  if(pageIsLoad){
      setPageIsLoad(false)
  }



  function add(){
    if (CODREL && LIMITE) {
      const newData: DataType = 
      {
        key: "0",
        NUMCPT : "", 
        CODREL: CODREL,
        LIMITE: LIMITE 
      };
      
      if (Donnee.find((d)=>d.CODREL == CODREL)) {
        SweetAlert.fire({title: "Attention", text : "Ce signataire existe déjà sur ce compte", icon : "warning"})

      }
      else
      {
        setDonnee([...Donnee, newData]);
        
        localStorage.setItem(Data.LocalVariable.Procurcpt, JSON.stringify([...Donnee, newData]))
      }
    }
    else{
      SweetAlert.fire({title: "Attention", text : "Veillez sélectionner les éléments indiqués", icon : "warning"})
    }
  }

  function loadData(){
    try{
      let data = JSON.parse(localStorage.getItem(Datas.LocalVariable.Procurcpt)+""); 
      if(data!==null) setDonnee(data);
    }catch(error){
      console.log(error)
    }
  }
  setTimeout(() => {

    if (Donnee.length == 0) {
      loadData();
    }
    try{
      
      let reset = localStorage.getItem(Datas.LocalVariable.Procurcpt);
      
      if (reset == null) {
        setDonnee([]);
      }
    }
    catch(error){
      console.log(error)  
    }
  }, 1);



  return(
    <div className='tabItem'>
      <div>
        <Box  fontStyle="inherit">
         <Box fontStyle="inherit" className = 'border-left border' width={"85%"} position={"absolute"}>
            <Box display={"flex"} className = "border-left" fontStyle="inherit" >
              <Box className = "border-left" >
                  <label htmlFor=""><b>Procuration </b></label>
                  <Select
                    onChange={handleChangeAgence}
                    value={CODREL}
                    id='codage'
                    size='middle'
                    style={{ width: 350 }}
                    options={props.OptionSignataire}
                  /> 
                </Box>
                <Box sx={{marginTop:-1}} className = "border-left" >
                  <InputForm notRequired money icon={<MoneyOffCsredOutlined/>} onChange={handleChangeGroupe} label='Limite de procuration' name='limiteP' type='number' ></InputForm>
                </Box>
                <Box className = "border-left" ><Button onClick={add} style={{ width: 100 }} size='large' icon = {<Add color='success'/>}/></Box>
              </Box>
              <legend>Procuration Habilité Au Compte</legend>
              <div>
                <Table size='small' columns={columns} pagination={{ pageSize: 5, position: ["bottomRight"] }} dataSource={Donnee} scroll={{ y:350, x: 1000 }} />
              </div>
            </Box>  
        </Box>
        <Modal width={800} open={previewOpen} title={previewTitle} footer={null} onCancel={handleCancel}>
              <img alt="example" style={{ width: '100%', maxHeight: 500 }} src={previewImage} />
            </Modal>
      </div>
    </div>
);
}

export default Tab3;